import React from "react";

import { Button } from "@/components/ui/button";
import { LoaderCircle } from "lucide-react";

const EmptyTableCTA = ({
  message = "Ready to get started?", 
  subMessage = "Click below to start",
  buttonLabel = "Start",
  onButtonClick = () => {},
  isFetching = false,
  Icon,
  loadingButtonLabel = "Loading ...",
}) => {
  return (
    <div className="rounded-lg border bg-background shadow-md relative w-full">
      <div className="flex items-center justify-center h-[400px] p-0">
        <div className="w-full max-w-md p-8 transition-all">
          <h2 className="text-2xl font-semibold text-foreground mb-6 text-center">
            {message}
          </h2>
          {subMessage && (
            <p className="text-center text-sm text-muted-foreground mb-4">
              {subMessage}
            </p>
          )}

          <Button
            className="w-full"
            onClick={onButtonClick}
            disabled={isFetching}
          >
            {isFetching ? (
              <LoaderCircle className="h-4 w-4 animate-spin" />
            ) : (
              Icon && <Icon size={20} />
            )}
            {isFetching ? loadingButtonLabel : buttonLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmptyTableCTA;
